import { Box, Divider, Group } from '@byecode/ui'
import type { ArgumentsSchema } from '@lighthouse/core'
import type { NodeTypes, VariableTriggerConfig } from '@lighthouse/shared'
import React, { useEffect, useState } from 'react'

import OutputVariable from '@/containers/FlowDetail/components/OutputVariable'

import { VariableListControlled } from '../../Common/VariableConfigure/VariableListControlled'
import * as SC from '../../styles'
import { LocationUsedList } from './LocationUsedList'

interface ArgConfigureProps {
    // allow NodeSetting to pass through even if not used here (keeps props uniform)
    nodeType?: NodeTypes
    onNodeTypeChange?: (val: NodeTypes) => void
    onNodeNameChange?: (name: string) => void
    value: VariableTriggerConfig
    onChange: (value: VariableTriggerConfig) => void
}

export const ArgConfigure: React.FC<ArgConfigureProps> = ({ value, onChange }) => {
    const [outputOptions, setOutputOptions] = useState<ArgumentsSchema[]>([])

    useEffect(() => {
        if (value?.args) {
            const list = value?.args?.map(item => ({
                id: item.id,
                name: item.name,
                desc: '传入子流程的参数',
                innerType: item.innerType
            }))
            setOutputOptions(list)
        }
    }, [value.args])

    return (
        <SC.Container>
            <Group label="传入流程参数">
                <Box>
                    <SC.Tip>定义子流程中使用的参数，参数值来自主流程。</SC.Tip>
                    <VariableListControlled value={value?.args} onChange={args => onChange({ ...value, args })} />
                </Box>
            </Group>
            <Divider color="var(--color-gray-200)" style={{ margin: '12px 0' }} />
            <Group label="使用了当前子流程的流程">
                <Box style={{ paddingTop: 8 }}>
                    <LocationUsedList />
                </Box>
            </Group>
            <OutputVariable options={outputOptions} />
        </SC.Container>
    )
}
